import { render, staticRenderFns } from "./ClearFilters.vue?vue&type=template&id=2da66a98&scoped=true"
import script from "./ClearFilters.vue?vue&type=script&lang=js"
export * from "./ClearFilters.vue?vue&type=script&lang=js"
import style0 from "./ClearFilters.vue?vue&type=style&index=0&id=2da66a98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da66a98",
  null
  
)

export default component.exports